import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { Container, Button } from "@mui/material";
import { VenueModal } from "./VenueModal";
import { useLocation, useNavigate } from "react-router-dom";
import { VENUE_DATA } from "../assets/const/constant";
import { VENUE_SELECTOR_CONST } from "../assets/const/venue-const";
import { constructUrl } from "../utils/utils";

const VenueSelector = ({customStyles, type, className}) => {
    const [venueModalOpen, setVenueModalOpen] = useState(false);
    const [error, setError] = useState(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const location = useLocation();
    const navigate = useNavigate();

    const handleClick = () => {
        setVenueModalOpen(true);
    }

    return (
        <Container sx={{}}>
            <Button
                type={!type ? "submit" : type !== "submit" ? type : ""}
                className={`${className}` ??  "avail-btn large"}
                data-test-id="footer-avail-btn"
                onClick={() => handleClick()}
                sx={!customStyles ? {} : {...customStyles}}
            >
                {isMobile ? 
                    VENUE_SELECTOR_CONST.signup_mobile 
                    : VENUE_SELECTOR_CONST.signup_desktop
                }
            </Button>
            <VenueModal 
                error={error}
                open={venueModalOpen}
                onClose={() => setVenueModalOpen(false)} 
            />
        </Container>
    )
}

export default VenueSelector;